export default class AddFieldworkPeriodsItem {
  PricingIds: number[];
  CountryNames: string[];
  NumberOfNewFieldworkPeriods: number;

  constructor(selectedItems) {
    const items = selectedItems ?? [];
    this.PricingIds = items.map((item) => item.PricingId);
    this.CountryNames = Array.from(new Set(items.map((item) => item.CountryName).filter(Boolean)));
    this.NumberOfNewFieldworkPeriods = 1;
  }
}
